export default __webpack_public_path__ + "static/immunefi-66141ba5860d4576d035a7cb202341c9.svg";